import { motion } from "framer-motion";
import { CheckCircle2, Globe2, MapPin } from "lucide-react";

const domestic = [
  "Corporate Tax Advisory & Structuring",
  "ITR Filing — Individuals, Firms & Corporates",
  "GST Compliance & Advisory",
  "Income Tax Notice Handling & Resolution",
  "Tax Planning & Consulting Services",
  "Tax-efficient Investment Planning for HNIs & NRIs",
];

const international = [
  "International Taxation & Transfer Pricing",
  "RBI Compliances — APR & FLA Filings",
  "Cross-Border Tax Structuring",
  "Wealth Preservation Strategies",
  "DTAA Analysis & Treaty Interpretation",
  "Foreign Investment Advisory",
];

const Block = ({ title, items, icon: Icon, accent, eyebrow, testid }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6 }}
    className="glass p-8 md:p-10 relative overflow-hidden"
  >
    <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-30 blur-3xl"
         style={{ background: accent }} />
    <div className="relative z-10">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl grid place-items-center border border-white/10"
             style={{ background: `${accent}1A` }}>
          <Icon size={20} style={{ color: accent }} />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em]" style={{ color: accent }}>{eyebrow}</div>
          <h3 className="font-heading font-semibold text-2xl text-white">{title}</h3>
        </div>
      </div>
      <ul className="mt-7 space-y-3.5">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-3 text-white/75 text-sm md:text-[15px]">
            <CheckCircle2 size={18} className="mt-0.5 shrink-0" style={{ color: accent }} />
            <span>{it}</span>
          </li>
        ))}
      </ul>
    </div>
  </motion.div>
);

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative section-pad overflow-hidden">
      <div className="shape-blob w-[420px] h-[420px] -left-32 top-40 opacity-30"
           style={{ background: "radial-gradient(circle, #FF8A3D 0%, transparent 70%)" }} />

      <div className="container-x relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="label-eyebrow mb-5">Services · the strategy layer</div>
          <h2 data-testid="services-title" className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            For Corporates, HNIs, NRIs <br />
            <span className="gradient-text-cool">& Individuals.</span>
          </h2>
          <p className="mt-6 text-white/65 max-w-2xl">
            A full-stack tax practice — from everyday compliance to cross-border structuring.
            One advisor, both sides of the border.
          </p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Block testid="services-domestic" title="Domestic" eyebrow="In India" items={domestic} icon={MapPin} accent="#16D1C8" />
          <Block testid="services-international" title="International" eyebrow="Cross-border" items={international} icon={Globe2} accent="#FF2D7A" />
        </div>
      </div>
    </section>
  );
};
